import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import { useEffect, useRef, useState } from "react"
import { Box, Button, CircularProgress, FormControlLabel, Link, Modal, Paper, Radio, RadioGroup, Table, TableCell, TableRow, Typography } from '@mui/material';

import ScrapReportDetails from "./scrap-report-details";
import { LinkDetails } from "./link-details";
import Paginator from "../GeneralComponents/paginator";
import ScrapReport from "./scrap-report";
import { link } from "fs";


export default function ScrapReportsPage({ failedReports }){


    let [infoOpen, setInfoOpen] = useState(false);
    let [selectedInfoScrapReport, setSelectedInfoScrapReport] = useState(null as any);

    let [linkOpen, setLinkOpen] = useState(false);
    let [selectedScrapReportAndLink, setSelectedScrapReportAndLink] = useState({ link: "", scrapReport: null as any});


    function handleCloseInfo(){
        setInfoOpen(false);
    }

    function handleShowInfo(scrapReport: any){
        setSelectedInfoScrapReport(scrapReport);
        setInfoOpen(true);
    }

    function handleLinkClicked(link: string, scrapReport: any){
        setSelectedScrapReportAndLink({ link: link, scrapReport: scrapReport });
        setLinkOpen(true);
    }

    function handleCloseLink(){
        setLinkOpen(false);
    }

    return(
        <>
            <ScrapReportsList failedReports={failedReports} handleInfoClick={handleShowInfo} handleOpenClick={handleLinkClicked} />
            <Modal sx={{ left: 100, top: 100, width:9/10 }} open={infoOpen} onClose={handleCloseInfo}>
                { selectedInfoScrapReport ? (
                    <>
                        <Paper elevation = {4} sx={{ padding: 5, paddingBottom: 2}}>
                            <ScrapReportDetails scrapReport={selectedInfoScrapReport} />
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Button sx={{ marginLeft: "auto" }} onClick={handleCloseInfo}>Close</Button>
                            </Box>
                        </Paper>
                    </>
                ):(<></>)}
            </Modal>
            <Modal sx={{ left: 100, top: 10, width:9/10 }} open={linkOpen} onClose={handleCloseLink}>
                <Paper sx={{ padding: 5, paddingBottom: 2 }} elevation={4}>
                    <LinkDetails scrapReport={selectedScrapReportAndLink.scrapReport} link={selectedScrapReportAndLink.link} handleCloseClicked={handleCloseLink} />
                    <Box sx={{ display:'flex', alignItems:'flex-end'}}  >
                        <Button sx={{ marginLeft: "auto" }} onClick={handleCloseLink}>Close</Button>
                    </Box>
                </Paper>
            </Modal>

      </>
    )
}



export function ScrapReportsList({failedReports, handleInfoClick = (scrapReport) => {}, handleOpenClick = (link, scrapReport) => {}}, handleOpenChiledClicked = (scraper) => {}){

    let [scrapReports, setScrapReports] = useState([] as any[]);
    let [scrapReportsCount, setScrapReportsCount] = useState(0);

    let [linksInStoryline, setLinksInStoryline] = useState([] as string[]);
    let [linksInStorylineReady, setLinksInStorylineReady] = useState(false);

    let [analysIsRunning, setAnalysIsRunning] = useState(false);

    let [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    let [loading, setLoading] = useState(false);

    let [lastOpenedScraper, setLastOpenedScraper] = useState(null);

    let [showFailedReports, setShowFaiiledReports] = useState(null);

    function openScraperTargetInChildWindow(scraper){
        setLastOpenedScraper(scraper);
        window.open(scraper.url, "child");
    }

    function reportsLoaded(scrapReports){ 
        setScrapReports(scrapReports);

        let allLinks = [] as string[];
        for(let scrapReport of scrapReports){
            if(scrapReport.bufferedNew){
                for(let link of scrapReport.bufferedNew){
                    allLinks.push(link);
                }
            }
        }
        setLoading(false);

        const allIncludedLinks = [] as string[];
        while(allLinks.length > 0){
            let newArray = allLinks.splice(10);
            console.log("Checking links chunk of size " + allLinks.length);
            StorylineServerProxy.checkLinksUnicity(allLinks).then(includedLinks => { allIncludedLinks.push(...includedLinks.links) }); 
            allLinks = newArray;
        }

        setLinksInStorylineReady(true);
    }

    function loadList(){

        setScrapReports([]);
        setLoading(true);
        setLinksInStorylineReady(false);

        if(failedReports){
            StorylineServerProxy.getFailedScrapReportsCount().then(count => {  setScrapReportsCount(count.count) });
            StorylineServerProxy.getFailedScrapReports(pageSize, pageNumber).then(scrapReports => reportsLoaded(scrapReports));    
        }
        else{
            StorylineServerProxy.getScrapReportsCount().then(count => {  setScrapReportsCount(count.count) });
            StorylineServerProxy.getScrapReports(pageSize, pageNumber).then(scrapReports => reportsLoaded(scrapReports));    
        }

    }

    useEffect(() => {
        loadList();
    }, [pageNumber, pageSize, showFailedReports]);


    if(showFailedReports != failedReports){
        setShowFaiiledReports(failedReports);
    }

    function handleDeleteClick(scrapReport){
        // NOTE: no confirmation, as this was slowing down the processing
        StorylineServerProxy.markScrapReportAsDeleted(scrapReport._id).then(() => {loadList()});
    }

    function handleAnalysisClick(scrapReport){
        setAnalysIsRunning(true)
        StorylineServerProxy.analyseScrapReport(scrapReport._id).then(() => {
            setAnalysIsRunning(false);
            loadList();
        });
    }



    function handleDeleteAllClicked(){
        StorylineServerProxy.markAllFailedAsDeleted().then(() => { loadList() });
    }


    return (
        <>
            <input type="hidden" id="lastOpenedScraper" value={JSON.stringify(lastOpenedScraper)}></input>
            <Paginator pageNumber={pageNumber} pageSize={pageSize} itemsCount={scrapReportsCount} itemType={"scrap reports"} setPageNumber={setPageNumber} setPageSize={setPageSize} />
            <br/>
            { failedReports?<><Button onClick={handleDeleteAllClicked} >Delete all</Button><br /><br /></>:<></> }
            {
                loading?<CircularProgress />:<></>
            }
            {
                scrapReports.map(scrapReport => {
                    return <ScrapReport scrapReport={scrapReport} handleOpenChildClicked={openScraperTargetInChildWindow} handleAnalysisClick={handleAnalysisClick} handleInfoClick={handleInfoClick} handleDeleteClick={handleDeleteClick} analysisIsRunning={analysIsRunning} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} loadList={loadList} handleLinkClicked={handleOpenClick}/>
                })
            }
        </>
    )
}
